import axios from "axios";
import { Job } from "../Items/Job";

const API_URL = "https://app.mamadapp.co.il/api/Job"; // עדכן לפי הכתובת שלך

class JobService {
  // --- GET_JOBS ---
  async getJobs(): Promise<Job[]> {
    const response = await axios.get(API_URL);
    const data = response.data;

    return data.map((j: any) => ({
      id: j.id,
      orderingCompanyId: j.orderingCompanyId,
      orderingCompany: j.orderingCompany ? { id: j.orderingCompany.id, name: j.orderingCompany.name } : null,
      propertyTypeId: j.propertyTypeId,
      propertyType: j.propertyType ? { id: j.propertyType.id, name: j.propertyType.name } : null,
      price: j.price,
      fileUpload: j.fileUpload,
      created: j.created,
      downloadUrl: j.downloadUrl,

    }));
  }

  // --- ADD_JOB ---
  async addJob(job: Job): Promise<Job> {
    const payload = {
      orderingCompanyId: job.orderingCompanyId,
      propertyTypeId: job.propertyTypeId,
      price: job.price,
      fileUpload: job.fileUpload,
    };

    const response = await axios.post(API_URL, payload);
    return response.data;
  }

  // --- EDIT_JOB ---
  async updateJob(id: number, job: Job): Promise<Job> {
    const payload = {
      orderingCompanyId: job.orderingCompanyId,
      propertyTypeId: job.propertyTypeId,
      price: job.price,
      fileUpload: job.fileUpload,
    };

    const response = await axios.put(`${API_URL}/${id}`, payload);
    return response.data;
  }

  // --- DELETE_JOB ---
  async deleteJob(id: number): Promise<void> {
    await axios.delete(`${API_URL}/${id}`);
  }
}

export default new JobService();


// import JobService from "../../services/JobService";
// import * as actionType from "../action";
// import { Job } from "../../Items/Job";

// // --- GET_JOBS ---
// export const fetchJobs = () => async (dispatch: any) => {
//   try {
//     const jobs: Job[] = await JobService.getJobs();
//     dispatch({ type: actionType.GET_JOBS, payload: jobs });
//   } catch (error) {
//     console.error("Error fetching jobs", error);
//   }
// };

// // --- ADD_JOB ---
// export const addJob = (job: Job) => async (dispatch: any) => {
//   try {
//     const newJob: Job = await JobService.addJob(job);
//     dispatch({ type: actionType.ADD_JOB, payload: newJob });
//   } catch (error) {
//     console.error("Error adding job", error);
//   }
// };

// // --- EDIT_JOB ---
// export const editJob = (id: number, job: Job) => async (dispatch: any) => {
//   try {
//     const updatedJob: Job = await JobService.updateJob(id, job);
//     dispatch({ type: actionType.EDIT_JOB, payload: updatedJob });
//   } catch (error) {
//     console.error("Error editing job", error);
//   }
// };

// // --- DELETE_JOB ---
// export const deleteJob = (id: number) => async (dispatch: any) => {
//   try {
//     await JobService.deleteJob(id);
//     dispatch({ type: actionType.DELETE_JOB, payload: id });
//   } catch (error) {
//     console.error("Error deleting job", error);
//   }
// };

